import * as React from 'react';

import * as AccordionPrimitive from '@radix-ui/react-accordion';

import { cn } from '@/lib/utils';

const Accordion = React.forwardRef<React.ElementRef<typeof AccordionPrimitive.Root>, React.ComponentPropsWithoutRef<typeof AccordionPrimitive.Root>>(
  ({ ...props }, ref) => <AccordionPrimitive.Root {...props} ref={ref} />,
);
Accordion.displayName = AccordionPrimitive.Root.displayName;

const AccordionItem = React.forwardRef<React.ElementRef<typeof AccordionPrimitive.Item>, React.ComponentPropsWithoutRef<typeof AccordionPrimitive.Item>>(
  ({ children, className, value, disabled, ...props }, ref) => (
    <AccordionPrimitive.Item ref={ref} value={value} disabled={disabled} className={cn('AccordionItem', className)}>
      {children}
    </AccordionPrimitive.Item>
  ),
);
AccordionItem.displayName = AccordionPrimitive.Item.displayName;

const AccordionHeader = React.forwardRef<React.ElementRef<typeof AccordionPrimitive.Header>, React.ComponentPropsWithoutRef<typeof AccordionPrimitive.Header>>(
  ({ children, className, ...props }, ref) => <AccordionPrimitive.Header ref={ref}>{children}</AccordionPrimitive.Header>,
);
AccordionHeader.displayName = AccordionPrimitive.Header.displayName;

const AccordionTrigger = React.forwardRef<
  React.ElementRef<typeof AccordionPrimitive.Trigger>,
  React.ComponentPropsWithoutRef<typeof AccordionPrimitive.Trigger>
>(({ children, className, ...props }, ref) => (
  <AccordionPrimitive.Header className="AccordionHeader">
    <AccordionPrimitive.Trigger className={cn('AccordionTrigger', className)} {...props} ref={ref}>
      {children}
    </AccordionPrimitive.Trigger>
  </AccordionPrimitive.Header>
));
AccordionTrigger.displayName = AccordionPrimitive.Trigger.displayName;

const AccordionContent = React.forwardRef<
  React.ElementRef<typeof AccordionPrimitive.Content>,
  React.ComponentPropsWithoutRef<typeof AccordionPrimitive.Content>
>(({ children, className, ...props }, ref) => (
  <AccordionPrimitive.Content
    className={cn('AccordionContent data-[state=closed]:animate-accordion-up data-[state=open]:animate-accordion-down overflow-hidden', className)}
    {...props}
    ref={ref}>
    <div className="AccordionContentText">{children}</div>
  </AccordionPrimitive.Content>
));
AccordionContent.displayName = AccordionPrimitive.Content.displayName;

export { Accordion, AccordionItem, AccordionHeader, AccordionTrigger, AccordionContent };
